/* eslint-disable arrow-body-style */
// @flow
import React, { memo, useId } from 'react';
import IconLink from 'components/atoms/icon-link/react/IconLink';
import { t } from 'javascripts/utils/withTranslation';
import classNames from 'classnames';
import type { Item } from '../types';
import VibaStatus from './VibaStatus';

const AuthorityCard = ({
  districtoffice,
  title = '',
  street,
  zip,
  city,
  homepage,
  emailbaurechtsbehoerde,
  pobox,
  poboxzip,
  vibastate = 0,
  vibalink,
  vibalinktext,
  highlighted,
}: Item & { vibalinktext?: string }): React$MixedElement => {
  const titleId = useId();
  return (
    <article
      className="auth-card"
      aria-label={`${title} ${districtoffice ? `- ${districtoffice}` : ''}`}
    >
      <header className="auth-card__header">
        <div className="auth-card__title">
          <h2 className="auth-card__headline" id={`authority-title-${titleId}`}>
            {title}
          </h2>
          <span className="auth-card__kicker">{districtoffice}</span>
        </div>
        <div className="auth-card__status">
          <VibaStatus
            appearance="icon"
            keyNumber={vibastate}
            text={vibalinktext}
          />
        </div>
      </header>
      <address className="auth-card__body">
        {/* {(pobox || poboxzip || city) && (
          <span className="auth-card__block">
            <span className="auth-card__term">
              {t('Postfach')}
              <br />
            </span>
            <span className="auth-card__text">
              {pobox && (
                <>
                  {pobox} <br />
                </>
              )}
              {(poboxzip || city) && (
                <>
                  {poboxzip} {city}
                </>
              )}
            </span>
          </span>
        )} */}
        {(street || city || zip) && (
          <span className="auth-card__block">
            <span className="auth-card__term">
              {t('Hausanschrift')}
              <br />
            </span>
            <span className="auth-card__text">
              {street && (
                <>
                  {street} <br />
                </>
              )}
              {(zip || city) && (
                <>
                  {zip} {city}
                </>
              )}
            </span>
          </span>
        )}
        {emailbaurechtsbehoerde && (
          <span className="auth-card__block">
            <span className="auth-card__term">
              {t('Kontakt')}
              <br />
            </span>
            <span className="auth-card__text">
              {emailbaurechtsbehoerde && (
                <a
                  className="link link--mail"
                  href={`mailto:${emailbaurechtsbehoerde}`}
                >
                  {emailbaurechtsbehoerde}
                </a>
              )}
            </span>
          </span>
        )}
      </address>

      <footer className="link-list auth-card__links">
        {(vibalink || homepage) && (
          <ul
            className="link-list__list auth-card__list"
            aria-label={t('Weiterführende Links')}
          >
            {vibalink && vibastate === 2 && (
              <li className="link-list__item">
                <IconLink
                  icon="external"
                  external
                  link={vibalink}
                  attr={{
                    'aria-describedby': `authority-title-${titleId}`,
                  }}
                  className="link-list__link"
                >
                  {t('Zum ViBa')}
                </IconLink>
              </li>
            )}
            {homepage && (
              <li className="link-list__item">
                <IconLink
                  icon="external"
                  external
                  link={homepage}
                  attr={{
                    'aria-describedby': `authority-title-${titleId}`,
                  }}
                  className="link-list__link"
                >
                  {t('Zur Baurechtsbehörde')}
                </IconLink>
              </li>
            )}
          </ul>
        )}
      </footer>
    </article>
  );
};
// $FlowFixMe
export default memo(AuthorityCard);
